import { render } from "./CustomerOrders.vue?vue&type=template&id=790edaca&scoped=true&ts=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts"

import "./CustomerOrders.vue?vue&type=style&index=0&id=790edaca&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790edaca"]])

export default __exports__